// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"11233c8c","917":"e9c6f6d3"}[chunkId] + ".chunk.js";
};